import { css } from '@emotion/css';
import {
  ColorsNeutral400,
  ColorsNeutral200,
  ColorsNeutral150,
  ColorsNeutral100,
  Dimensions1,
  Dimensions2,
  Dimensions3,
  Dimensions5,
  Radius1,
  ShadowsBox,
} from '@efexteam/design-tokens';
import { NAVBAR_DIMENSIONS } from './constants/navbar.constants';

const langSelectorContainer = css({
  position: 'relative',
});

const langSelectorButton = css({
  display: 'flex',
  alignItems: 'center',
  padding: `${Dimensions2} ${Dimensions3}`,
  borderRadius: Radius1,
  cursor: 'pointer',
  color: ColorsNeutral400,
  backgroundColor: ColorsNeutral100,
  backdropFilter: 'blur(4px)',
  border: `1px solid ${ColorsNeutral200}`,
  boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, 0.05)`,
  transition: 'box-shadow 0.2s ease-in-out',
  height: `${NAVBAR_DIMENSIONS.DESKTOP_HEIGHT}px`,
  minWidth: `${NAVBAR_DIMENSIONS.DESKTOP_MIN_WIDTH}px`,
  justifyContent: 'space-between',
  gap: Dimensions2,

  '&:hover': {
    boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, ${ShadowsBox.colorOpacity})`,
  },

  '& svg': {
    width: Dimensions5,
    height: Dimensions5,
  },
});

const langSelectorButtonMobile = css({
  padding: `4px ${Dimensions1}`,
  height: `${NAVBAR_DIMENSIONS.MOBILE_HEIGHT}px`,
  minWidth: `${NAVBAR_DIMENSIONS.MOBILE_MIN_WIDTH_LANG}px`,
  gap: Dimensions1,
});

const langSelectorContent = css({
  display: 'flex',
  alignItems: 'center',
  gap: Dimensions2,
});

const langSelectorText = css({
  fontSize: '14px',
  fontWeight: 500,
  display: 'none',
});

const langSelectorTextDesktop = css({
  display: 'block',
});

const langSelectorTextMobile = css({
  display: 'block',
  fontSize: '12px',
});

const dropdown = css({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  zIndex: 10,
  backgroundColor: ColorsNeutral100,
  backdropFilter: 'blur(4px)',
  border: `1px solid ${ColorsNeutral200}`,
  borderRadius: Radius1,
  boxShadow: `${ShadowsBox.offsetX} ${ShadowsBox.offsetY} ${ShadowsBox.blur} ${ShadowsBox.spread} rgba(0, 0, 0, ${ShadowsBox.colorOpacity})`,
  marginTop: '4px',
});

const dropdownOption = css({
  display: 'flex',
  alignItems: 'center',
  padding: `${Dimensions2} ${Dimensions3}`,
  cursor: 'pointer',
  fontSize: '14px',
  transition: 'background-color 0.2s ease-in-out',
  border: 'none',
  backgroundColor: 'transparent',
  width: '100%',
  textAlign: 'left',
  gap: Dimensions2,
  position: 'relative',

  '&:hover': {
    backgroundColor: 'transparent',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '2px',
      left: '4px',
      right: '4px',
      bottom: '2px',
      backgroundColor: ColorsNeutral150,
      borderRadius: Radius1,
      zIndex: -1,
    },
  },

  '&:first-child': {
    borderTopLeftRadius: Radius1,
    borderTopRightRadius: Radius1,
  },

  '&:last-child': {
    borderBottomLeftRadius: Radius1,
    borderBottomRightRadius: Radius1,
  },
});

const langSelectorStyles = {
  langSelectorContainer,
  langSelectorButton,
  langSelectorButtonMobile,
  langSelectorContent,
  langSelectorText,
  langSelectorTextDesktop,
  langSelectorTextMobile,
  dropdown,
  dropdownOption,
};

export default langSelectorStyles;
